import * as React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export function SitemarkIcon() {
  return (
    <SvgIcon sx={{ height: 100, width: 100 }}>
    <svg  version="1.0" xmlns="http://www.w3.org/2000/svg"  width="900.000000pt" height="900.000000pt" viewBox="0 0 900.000000 900.000000"  preserveAspectRatio="xMidYMid meet">  <g transform="translate(0.000000,900.000000) scale(0.100000,-0.100000)" fill="#e90c0c" stroke="none"> <path d="M4588 5772 l-478 -2 0 -140 0 -140 248 -1 c209 0 253 -3 288 -17 50 -21 81 -46 117 -93 48 -63 57 -115 58 -334 0 -110 4 -208 8 -218 6 -16 21 -19 129 -20 l122 -2 0 482 c0 265 -3 483 -7 485 -5 2 -223 2 -485 0z"/> <path d="M920 5631 l0 -138 55 -6 c137 -14 234 -80 255 -173 12 -48 12 -1530 1 -1597 -16 -94 -88 -152 -221 -177 l-85 -16 0 -135 0 -134 773 -3 773 -2 -3 142 -3 143 -68 7 c-85 10 -155 45 -198 100 l-34 42 -3 786 c-2 432 0 808 3 836 12 100 105 171 240 183 39 3 69 9 68 14 -2 4 -3 66 -3 137 l0 130 -775 0 -775 0 0 -139z"/> <path d="M2700 5630 l0 -140 27 0 c44 0 145 -32 190 -59 52 -32 78 -65 92 -116 15 -53 15 -1541 0 -1604 -12 -52 -59 -115 -102 -138 -39 -19 -131 -42 -174 -43 l-33 0 0 -140 0 -140 775 0 775 0 0 139 0 138 -77 13 c-113 18 -165 50 -216 132 -16 25 -17 110 -17 1063 l0 1035 -620 0 -620 0 0 -140z"/> <path d="M5290 5630 l0 -140 26 0 c14 0 56 -7 93 -16 82 -20 153 -68 181 -124 20 -38 20 -56 20 -841 l0 -801 -25 -47 c-38 -68 -100 -106 -205 -123 l-85 -14 -3 -137 -3 -137 616 0 615 0 5 23 c3 12 4 578 3 1257 l-3 1235 -617 3 -618 2 0 -140z"/> <path d="M6709 5765 c-8 -7 -2 -272 5 -284 4 -6 27 -11 50 -11 240 0 406 -161 406 -393 0 -122 -40 -219 -117 -287 -68 -59 -130 -88 -231 -106 -48 -9 -93 -19 -101 -23 -10 -5 -13 -35 -13 -126 l0 -120 68 -6 c191 -17 338 -98 399 -219 28 -55 56 -183 49 -225 -16 -100 -29 -155 -47 -189 -28 -57 -113 -138 -177 -168 -60 -28 -177 -56 -250 -60 l-45 -3 0 -135 c0 -74 3 -141 8 -147 14 -20 825 -18 927 2 146 28 300 119 389 231 46 56 99 158 122 229 25 79 26 264 3 339 -36 115 -87 202 -171 291 -35 38 -164 125 -184 125 -8 0 -23 6 -34 14 -11 7 -33 16 -48 20 -38 9 -33 45 9 66 58 29 161 109 207 160 152 169 180 464 65 695 -34 68 -42 79 -87 127 -46 50 -187 148 -212 148 -8 0 -19 4 -25 10 -5 5 -43 19 -84 30 -69 18 -108 20 -476 20 -220 0 -403 -2 -405 -5z"/> <path d="M4327 5114 c-4 -4 -7 -63 -7 -131 0 -110 -2 -127 -22 -156 -27 -41 -68 -66 -133 -81 l-50 -11 -3 -118 -3 -117 34 0 c44 0 116 -32 147 -65 23 -25 25 -35 30 -163 l5 -137 125 0 125 0 0 490 0 490 -121 3 c-66 1 -123 -1 -127 -4z"/> </g> </svg> 
    </SvgIcon>
  );
}

export function FacebookIcon() {
  return (
    <SvgIcon>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.68 15.92C2.88 15.24 0 11.96 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8C16 11.96 13.12 15.24 9.32 15.92L8.88 15.56H7.12L6.68 15.92Z"
          fill="url(#paint0_linear_795_116)"
        />
        <path
          d="M11.12 10.2391L11.48 7.99914H9.36V6.43914C9.36 5.79914 9.6 5.31914 10.56 5.31914H11.6V3.27914C11.04 3.19914 10.4 3.11914 9.84 3.11914C8 3.11914 6.72 4.23914 6.72 6.23914V7.99914H4.72V10.2391H6.72V15.8791C7.16 15.9591 7.6 15.9991 8.04 15.9991C8.48 15.9991 8.92 15.9591 9.36 15.8791V10.2391H11.12Z"
          fill="white"
        />
        <defs>
          <linearGradient
            id="paint0_linear_795_116"
            x1="8"
            y1="0"
            x2="8"
            y2="15.9991"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1AAFFF" />
            <stop offset="1" stopColor="#0163E0" />
          </linearGradient>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export function GoogleIcon() {
  return (
    <SvgIcon>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.68 8.18182C15.68 7.61455 15.6291 7.06909 15.5345 6.54545H8V9.64364H12.3055C12.1164 10.64 11.5491 11.4836 10.6982 12.0509V14.0655H13.2945C14.8073 12.6691 15.68 10.6182 15.68 8.18182Z"
          fill="#4285F4"
        />
        <path
          d="M8 16C10.16 16 11.9709 15.2873 13.2945 14.0655L10.6982 12.0509C9.98545 12.5309 9.07636 12.8218 8 12.8218C5.92 12.8218 4.15273 11.4182 3.52 9.52727H0.858182V11.5927C2.17455 14.2036 4.87273 16 8 16Z"
          fill="#34A853"
        />
        <path
          d="M3.52 9.52C3.36 9.04 3.26545 8.53091 3.26545 8C3.26545 7.46909 3.36 6.96 3.52 6.48V4.41455H0.858182C0.312727 5.49091 0 6.70545 0 8C0 9.29455 0.312727 10.5091 0.858182 11.5855L2.93091 9.97091L3.52 9.52Z"
          fill="#FBBC05"
        />
        <path
          d="M8 3.18545C9.17818 3.18545 10.2255 3.59273 11.0618 4.37818L13.3527 2.08727C11.9636 0.792727 10.16 0 8 0C4.87273 0 2.17455 1.79636 0.858182 4.41455L3.52 6.48C4.15273 4.58909 5.92 3.18545 8 3.18545Z"
          fill="#EA4335"
        />
      </svg>
    </SvgIcon>
  );
}
